/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { MdExpandLess, MdExpandMore, MdCheck } from 'react-icons/md';

const AMENITY_CATEGORIES = [
  {
    name: 'Accessibility',
    keys: ['wheelchair', 'accessible', 'disabled access'],
  },
  {
    name: 'Bar',
    keys: ['bar', 'barber', 'beauty shop', 'minibar', 'mini bar'],
  },
  {
    name: 'Basic Facility',
    keys: [
      'lift',
      'elevator',
      'non-smoking',
      'smoking room',
      'ironing',
      'iron',
      'hair dryer',
      'safe',
    ],
  },
  {
    name: 'Business & Conference',
    keys: [
      'business center',
      'business centre',
      'fax',
      'photocopy',
      'meeting',
      'conference',
      'banquet hall',
      'board room',
    ],
  },
  {
    name: 'Entertainment & Tech',
    keys: [
      'car hire',
      'car rental',
      'private check-in',
      'tour desk',
      'express check-in',
      'express check-out',
      'television',
      'nightclub',
      'casino',
      'game',
    ],
  },
  {
    name: 'Food & Drinks',
    keys: [
      'breakfast',
      'restaurant',
      'packed lunch',
      'dinner',
      'kitchen',
      'vending',
      'snack bar',
      'cafe',
      'coffee',
    ],
  },
  {
    name: 'Guest Services',
    keys: [
      'concierge',
      'luggage storage',
      'trouser press',
      'invoice',
      'dry cleaning',
      'laundry',
      'currency exchange',
      'safety deposit',
      'daily housekeeping',
      'housekeeping',
      '24-hour front desk',
      'front desk',
      'facilities for disabled',
    ],
  },
  {
    name: 'Health & Wellness',
    keys: [
      'fitness',
      'gym',
      'wellness',
      'sauna',
      'steam room',
      'hot tub',
      'jacuzzi',
    ],
  },
  { name: 'Internet', keys: ['wifi', 'wi-fi', 'internet', 'wireless'] },
  {
    name: 'Outdoor Areas',
    keys: [
      'garden',
      'terrace',
      'outdoor',
      'balcony',
      'patio',
      'sundeck',
      'beach',
    ],
  },
  { name: 'Room Service', keys: ['room service'] },
  { name: 'Spa', keys: ['spa', 'massage'] },
  {
    name: 'Sports',
    keys: [
      'golf',
      'tennis',
      'sport',
      'bicycle',
      'cycling',
      'squash',
      'billiards',
      'swimming pool',
      'pool',
    ],
  },
  { name: 'Parking', keys: ['parking', 'car park', 'garage'] },
  {
    name: 'Transportation',
    keys: [
      'airport shuttle',
      'shuttle',
      'transfer',
      'taxi',
      'transport',
      'bus',
    ],
  },
];

function categorizeAmenities(fcList) {
  const categorized = {};
  const usedItems = new Set();

  // Match each amenity to its first matching category
  AMENITY_CATEGORIES.forEach(({ name, keys }) => {
    const matched = fcList.filter((item) => {
      const lower = item.toLowerCase();
      return keys.some((k) => lower.includes(k));
    });
    if (matched.length > 0) {
      categorized[name] = matched;
      matched.forEach((m) => usedItems.add(m));
    }
  });

  // Any unmatched items go to "Other"
  const other = fcList.filter((item) => !usedItems.has(item));
  if (other.length > 0) {
    categorized.Other = other;
  }

  return categorized;
}

export default function HotelDetailsAmenities({ hotelDetails, amenitiesRef }) {
  const [showAll, setShowAll] = useState(false);

  const fcList = hotelDetails.fcList || [];
  const categorized = categorizeAmenities(fcList);
  const categoryEntries = Object.entries(categorized);

  const INITIAL_COLS = 4;
  const visibleEntries = showAll
    ? categoryEntries
    : categoryEntries.slice(0, INITIAL_COLS);

  return (
    <section ref={amenitiesRef} id="amenities" className="hdp-section">
      <h3 className="hdp-section__title mt-2">Amenities</h3>
      <p className="hdp-amenities__note">
        Amenities are subject to availability and may be chargeable as per the
        hotel policy
      </p>
      <div className="hdp-amenities-cat__grid">
        {visibleEntries.map(([category, items]) => (
          <div key={category} className="hdp-amenities-cat__col">
            <h4 className="hdp-amenities-cat__heading">{category}</h4>
            <ul className="hdp-amenities-cat__list">
              {items.map((item) => (
                <li key={item} className="hdp-amenities-cat__item">
                  <MdCheck className="hdp-amenities-cat__check" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {categoryEntries.length > INITIAL_COLS && (
        <button
          type="button"
          className="hdp-amenities__toggle-btn"
          onClick={() => setShowAll((p) => !p)}
        >
          {showAll ? (
            <>
              <MdExpandLess /> Show Less
            </>
          ) : (
            <>
              <MdExpandMore /> View All Amenities
            </>
          )}
        </button>
      )}
    </section>
  );
}
